/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import Space from 'material/space/space';
import { SectionGroupV2 } from 'material/expandablesection/v2'
import { SingleSelectDropDown, Tip } from '@insticator/insticator-ui'
// content
import PreviewConfig from '../../previewconfig/previewconfig'
import Avatar from '../components/avatar/avatar';
// styles
import injectSheet from 'react-jss'
import styles from './defaultavatarpack_styles'

const avatarPackOptions = [
  { name: 'General', value: 'GENERAL'},
  { name: 'Entertainment', value: 'ENTERTAINMENT'},
  { name: 'Hobbies', value: 'HOBBIES_AND_INTERESTS'},
  { name: 'Education', value: 'EDUCATION_AND_PROFESSIONAL'},
  { name: 'Sports', value: 'SPORTS'},
  { name: 'Science', value: 'SCIENCE'},
  { name: 'Home', value: 'HOME'},
  { name: 'News', value: 'NEWS'}
]

const avatarPackMap = (name) => {
  return avatarPackOptions.filter(avatarPack => avatarPack.value === name)?.pop() || avatarPackOptions[0]
}
/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: SITE THEME SECTION : DEFAULT AVATAR PACK ~~~~~~~~~~ ========== */
const DefaultAvatarPack = injectSheet(styles)((props) => {

  const { siteTheme, setSiteThemeConfig } = props

  const handleDefaultAvatarPackChange = opt => {
    setSiteThemeConfig('avatarPack', opt.value)
  }

  return (
    <SectionGroupV2 
      klass={`defaultavatarpack ${props.classes.defaultavatarpack}`}
      title={'Avatar Pack'} 
      description={<span>Select an avatar theme that matches your sites content. <Tip space={'none'} icon={'question-circle'} content={'These avatars are randomly assigned to users who don’t upload their own customized photo.'} label={''} /></span>}
      indented
      direction={'column'}
    >
      <Space>
        <SingleSelectDropDown 
          name={avatarPackMap(siteTheme.avatarPack).name} 
          searchable={false} 
          onSelect={handleDefaultAvatarPackChange}
          items={avatarPackOptions}
        />
      </Space>
      <PreviewConfig>
        <Space direction={'column'} gap={22}>
          <Space flexWrap={true} gap={48} justifyContent={'center'}>      
            {/* TODO: props.themeExtension should be fetched from redux state */}
            {[1,2,3,4].map(index => <Avatar extension={siteTheme.themeExtension || 'GENERAL'} name={`${siteTheme.avatarPack}_${index}`} />)}
          </Space>
          <Space flexWrap={true} gap={48} justifyContent={'center'}>
            {[5,6,7,8].map(index => <Avatar extension={siteTheme.themeExtension || 'GENERAL'} name={`${siteTheme.avatarPack}_${index}`} />)}
          </Space>
          <Space flexWrap={true} gap={48} justifyContent={'center'}>
            {[9,10,11,12].map(index => <Avatar extension={siteTheme.themeExtension || 'GENERAL'} name={`${siteTheme.avatarPack}_${index}`} />)}
          </Space>
        </Space>
      </PreviewConfig>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default DefaultAvatarPack